import FileSaver from "file-saver";

import api from "../../services/api";

const useDashboard = () => {

    const find = async (params) => {
        const { data } = await api.request({
            url: `/dashboard`,
            method: 'GET',
            params
        });
        return data;
    }

    const getReport = async (params) => {
        const { data } = await api.request({
            url: `/ticketreport/reports`,
            method: 'GET',
            params
        });
        return data;
    }

    const downloadCsv = async (url, params, filename) => {
        const { data } = await api.request({
            url,
            method: "GET",
            params,
            responseType: "blob"
        });

        const blob = new Blob([data], { type: "text/csv;charset=utf-8" });
        FileSaver.saveAs(blob, filename);
    };

    const downloadReportCsv = async (params) => {
        return downloadCsv("/ticketreport/reports/export", params, "relatorio-de-atendimentos.csv");
    };

    const downloadAllConversationsCsv = async (params) => {
        return downloadCsv("/ticketreport/conversations/export", params, "todas-as-conversas.csv");
    };

    return {
        find,
        getReport,
        downloadReportCsv,
        downloadAllConversationsCsv
    }
}

export default useDashboard;